/**
 * @fileoverview GET handler for the "/app_settings/objects_using_custom_events" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appSettingsObjectsUsingCustomEvents } from "./constants";
import type { AppSettingsObjectsUsingCustomEventsResult } from "./types";

export const getAppSettingsObjectsUsingCustomEvents = reactQueryFetcherAdapter(
  appSettingsObjectsUsingCustomEvents,
  (signal: AbortSignal, itemNames: string[]): Promise<AppSettingsObjectsUsingCustomEventsResult> => {
    return fetch("/app_settings/objects_using_custom_events", "GET", { item_names: itemNames }, { signal });
  }
);
